import { Loading } from '@components/loading/Loading';
import React from 'react';

export default () => <Loading global />;
